import { Image } from "../Image/Image";

export const PopupSideBarImage = ({src, alt, ...props}) => {
    return <Image src={src + "?widht=537&height=358"} alt={alt} />
}